import { FC, ReactElement, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Stack, styled, IconButton, Box } from "@mui/material";
import { Menu as MenuIcon } from "@mui/icons-material";

import { Sidebar } from "./sidebar";

import { useThemeBreakPoints } from "@/hooks";
import { layoutDimensions } from "@/utils/responsive";

const LayoutBox = styled("div")(({ theme }) => ({
  display: "flex",
  flex: "1 1 auto",
  flexDirection: "column",
  width: "100%",
  padding: `${layoutDimensions.layoutPaddingSmall} ${layoutDimensions.layoutPaddingMedium}`,
  overflow: 'auto',
  [theme.breakpoints.up("md")]: {
    padding: `${layoutDimensions.layoutPaddingMedium} ${layoutDimensions.layoutPaddingLarge}`,
  },
}));

const LoggedinLayout: FC = (): ReactElement => {
  const { isMatched: IsMdUp } = useThemeBreakPoints({
    action: "up",
    breakpoint: "md",
    
  });

  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [isSidebarExtended, setSidebarExtended] = useState<boolean>(true);

  // Listen for global events to control main sidebar expansion
  useEffect(() => {
    const handleSet = (e: Event) => {
      try {
        const detail = (e as CustomEvent).detail;
        setSidebarExtended(Boolean(detail));
      } catch {
        // noop
      }
    };
    const handleExpand = () => setSidebarExtended(true);
    const handleCollapse = () => setSidebarExtended(false);
    window.addEventListener('td:setSidebarExtended', handleSet as EventListener);
    window.addEventListener('td:expandSidebar', handleExpand);
    window.addEventListener('td:collapseSidebar', handleCollapse);
    return () => {
      window.removeEventListener('td:setSidebarExtended', handleSet as EventListener);
      window.removeEventListener('td:expandSidebar', handleExpand);
      window.removeEventListener('td:collapseSidebar', handleCollapse);
    };
  }, []);


  const getPaddingLeft = () => {
    if (IsMdUp) {
      return isSidebarExtended ? layoutDimensions.sidebarExtended : layoutDimensions.sidebarCollapsed;
    }
    return "0px";
  };

  return (
    <>
      <Stack
        sx={{
          display: "flex",
          flex: "1 1 auto",
          maxWidth: "100%",
          width: "100%",
          paddingLeft: getPaddingLeft(),
          transition: "0.3s",
          height: "100vh",
          overflow: 'hidden',
          position: "relative"
        }}
      >
        {!IsMdUp && (
           <Box sx={{ p: 2, display: "flex", alignItems: "center" }}>
             <IconButton
               onClick={() => setSidebarOpen(true)}
               color="primary"
             >
               <MenuIcon />
             </IconButton>
           </Box>
        )}
        <LayoutBox
          sx={{
            backgroundColor: "#FFFFFF",
            height: "100%",
          }}
        >
          <Outlet />
        </LayoutBox>
      </Stack>
      
      <Sidebar
        onClose={() => setSidebarOpen(false)}
        open={isSidebarOpen}
        isSidebarExtended={isSidebarExtended}
        onSidebarExtend={() => setSidebarExtended(!isSidebarExtended)}
      />
    </>
  );
};

export default LoggedinLayout;
